import { ActuatorTypes } from 'src/actuators/user-input/calculations/constants.ts';
import { RegionsEnum } from 'src/generated/operations.ts';
import { Units } from 'uom-units';
import { PoundInch } from 'src/utils/PoundInch.ts';

export const detectTargetUnit = (selectedActuatorType: ActuatorTypes, currentRegion: RegionsEnum) => {
    if (selectedActuatorType === ActuatorTypes.Linear) {
        return currentRegion === RegionsEnum.Am ? Units.PoundForce : Units.Newton;
    }
    return currentRegion === RegionsEnum.Am ? PoundInch : Units.NewtonMeter;
};
